import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import decoMethodCategoryService from "../../../../services/decoMethodCategoryService";
import DecoMethodCategoryForm from "./forms/DecoMethodCategoryForm";

function DecoMethodCategoryAddEdit() {
  const { id } = useParams();
  let history = useHistory();
  const { decoMethodCategoryState } = useMastersContext();

  const [data, setData] = useState({
    dcM_ID: -1,
    decoCategory: "",
    artColors: "",
    colorsMax: -1,
    productExamples: "",
    colorPricingCategoryID: -1,
    noColorIncluded: "1",
    noLocIncluded: "",
    pricingType: "",
    decoMethod_ID: -1,
    name: "",
    hyphanateName: "",
  });

  const init = async () => {
    if (id) {
      const result = await decoMethodCategoryService.getOne(id);
      setData(result);
    }
  };

  useEffect(() => {
    init();
  }, []);

  const saveHandler = async () => {
    const postData = {
      Id: data.dcM_ID,
      DecoCategory: data.decoCategory,
      ArtColors: data.artColors,
      DecoMethodId: data.decoMethod_ID,
      ColorsMax: data.colorsMax,
      ProductExample: data.productExamples,
      ColorPricingCatId: data.colorPricingCategoryID,
    };

    if (id) {
      const result = await decoMethodCategoryService.update(postData);
      if (result.success === true) {
        //decoMethodCategoryState.fetch();
        history.goBack();
      }
    } else {
      // const result = await decoMethodCategoryService.add(postData);
      // if (result.success === true) {
      //   decoMethodCategoryState.fetch();
      //   history.goBack();
      // }
      history.goBack();
    }
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} Category Secondary Option</h4>
      <hr />
      <div>
        <DecoMethodCategoryForm formData={data} setFormData={setData} />
        <hr />
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-sm btn-danger mr-5"
            onClick={(e) => history.goBack()}
          >
            Cancel
          </button>
          <button
            className="btn btn-sm btn-success"
            onClick={(e) => saveHandler()}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default DecoMethodCategoryAddEdit;
